import React, { createContext, useContext } from 'react';
import useUserData from '../hooks/useUserData';

// Create the context
const UserDataContext = createContext(null);

/**
 * Provider component for user data
 * @param {Object} props - Component props
 * @param {boolean} props.autoSubscribe - Whether to auto-subscribe on mount
 * @param {React.ReactNode} props.children - Child components
 */
export const UserDataProvider = ({ 
  autoSubscribe = true, 
  children 
}) => {
  const userData = useUserData(autoSubscribe);
  
  return (
    <UserDataContext.Provider value={userData}>
      {children}
    </UserDataContext.Provider>
  );
};

/**
 * Custom hook to access user data from context
 * @returns {Object} User data state and management functions
 */
export const useUserDataContext = () => {
  const context = useContext(UserDataContext);
  if (!context) {
    throw new Error('useUserDataContext must be used within a UserDataProvider');
  }
  return context;
};

export default UserDataContext; 